const BADGE_LOGO =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_089484a9-207c-4c94-ac2c-0d641d6dd996/artifacts/hls32p7k_2908C789-3D37-430E-8219-D8A7A677B8B1.png";

export const BrandMark = ({ size = "w-8 h-8" }) => (
  <span className={`${size} rounded-full overflow-hidden inline-block border border-white/20 shrink-0`}>
    <img src={BADGE_LOGO} alt="DUMP'D logo" className="w-full h-full object-cover scale-[1.12]" />
  </span>
);

export default function Header() {
  return (
    <header className="sticky top-0 z-50 bg-neutral-950/95 backdrop-blur-md border-b border-white/10 px-4 py-2.5">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <a href="#hero" className="flex items-center gap-2 group" data-testid="brand-home-link">
            <BrandMark />
            <span className="font-display text-lg tracking-tight uppercase group-hover:opacity-80 transition-opacity">
              DUMP'D
            </span>
          </a>
          <span className="hidden md:inline-block text-xs font-mono text-zinc-400 border-l border-zinc-800 pl-3 uppercase tracking-wider">
            Clear Space. Better Days.
          </span>
        </div>

        <nav className="hidden lg:flex items-center gap-6 text-xs font-semibold tracking-wider uppercase text-zinc-300">
          <a href="#services" data-testid="nav-services" className="hover:text-white transition-colors">Services</a>
          <a href="#why-dumpd" data-testid="nav-why-us" className="hover:text-white transition-colors">Why Us</a>
          <a href="#service-area" data-testid="nav-service-area" className="hover:text-white transition-colors">Service Area</a>
          <a href="#gallery" data-testid="nav-hauls" className="hover:text-white transition-colors">Hauls</a>
          <a href="#pricing-guide" data-testid="nav-how-it-works" className="hover:text-white transition-colors">How It Works</a>
          <a href="#pricing" data-testid="nav-pricing" className="hover:text-white transition-colors">Pricing</a>
          <a href="#faq" data-testid="nav-faq" className="hover:text-white transition-colors">FAQ</a>
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="header-quote-btn"
            className="hidden sm:inline-flex items-center justify-center px-4 py-2 rounded-lg text-xs font-bold uppercase tracking-wider bg-zinc-900 border border-zinc-700 text-white hover:bg-zinc-800 transition-colors"
          >
            Get Online Quote
          </a>
          <a
            href="tel:3214202707"
            data-testid="header-call-btn"
            className="inline-flex items-center justify-center px-4 py-2 rounded-lg text-xs font-black uppercase tracking-wider bg-white text-black hover:bg-zinc-200 transition-colors shadow-md"
          >
            Call (321) 420-2707
          </a>
        </div>
      </div>
    </header>
  );
}
